// @flow
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type Props = {
  record: any,
  policy: any,
};

class Diagnostics extends React.PureComponent<Props> {
  constructor(props: Props) {
    super();
  }

  render() {
    let { policy } = this.props;
    let attributes = ['id'].concat(Object.keys(policy.attributes));
    return (
      <Table sx={{ marginTop: 2 }}>
        <TableBody>
          {attributes.map(attribute => this.renderAttribute(attribute))}
        </TableBody>
      </Table>
    );
  }

  renderAttribute(attribute: string) {
    let { record } = this.props;
    if (record[attribute] === undefined) {
      return null;
    }
    let value = (record[attribute] == null ? '' : record[attribute]).toString();
    return (
      <TableRow sx={{ height: 3 }} key={attribute}>
        <TableCell>{attribute}</TableCell>
        <TableCell>{value}</TableCell>
      </TableRow>
    );
  }
}

export default Diagnostics;
